// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCbtyPrygM-zgrGkW9hAgXH4JE8HMIXXCY",
  authDomain: "mango-learning-manager.firebaseapp.com",
  projectId: "mango-learning-manager",
  storageBucket: "mango-learning-manager.firebasestorage.app",
  messagingSenderId: "675615775196",
  appId: "1:675615775196:web:ead3d93df1a7d680341719",
  measurementId: "G-JK6JZ9P1FF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
// const analytics = getAnalytics(app);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    const token = await getToken(messaging, {
      vapidKey: "BInY0TWnH0IJW5pGbSL-xnKpuu5dY83ZMDY36OPLrl47oyfsKnHv7mUTU-tOfszqVBqAh6PP_7Kez7-kbYBNbvw",
    });
    console.log(token);
    localStorage.setItem('device_token', token);
  }
};

export { messaging };
